export const menuItems = [
    { title: "Главная", link: "/main" },
    {
        title: "Программы",
        link: "/treatment",
        submenu: [
            {
                title: "Методы лечения",
                link: "/treatment",
                submenu: [
                    { title: "ЭКГ - Электрокардиограмма", link: "/treatment" },
                    { title: "Грязелечение тамбуканской грязью", link: "/treatment" },
                    { title: "Магнитотерапия", link: "/treatment" },
                    { title: "Терренкур", link: "/treatment" },
                    { title: "ЛФК – Лечебная физическая культура", link: "/treatment" },
                    { title: "Лечебное плавание", link: "/treatment" },
                    { title: "Скандинавская ходьба", link: "/treatment" },
                    { title: "Ударно-волновая терапия", link: "/treatment" },
                ]
            },
        ]
    },
    {
        title: "Номера",
        link: "/rooms",
    },
    {
        title: "Услуги",
        link: "/food",
        submenu: [
            { title: "Досуг", link: "/food" },
            { title: "Инфраструктура", link: "/food" }
        ]
    },
    {title: "Информация",link: "/info",}
];